<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"/>

    <end-shift-report ref="endShiftReport"/>
    <end-shift-report-v2 ref="endShiftReportV2"/>
  </div>
</template>
<script>
import dateFormat from '../../../mixins/date-format';
import endShiftReport from './end-shift-report.vue';
import endShiftReportV2 from './end-shift-report-v2.vue';

export default {
    components: { endShiftReport, endShiftReportV2 },
    mixins: [dateFormat],

    data() {
        return {
            tableName: 'VUETABLE_DRAWER_SESSION',
            columns: [
                'uuid',
                'staff',
                'outlet',
                'time_open',
                'time_close',
                'price_before_modifiers',
                'total_discounts',
                'net_sales',
                'total_sales',
                'voided_sales',
                'voided_items',
                'total_rounding',
                'total_cash',
                'total_credit_card',
                'total_cheque',
                'total_voucher',
                'total_others',
                'opening_amount',
                'cash_in',
                'cash_out',
                'expected_drawer_amount',
                'closing_amount',
                'short_extra',
            ],
            options: {
                columnsDropdown: true,
                headings: {
                    uuid: 'Shift ID',
                    short_extra: 'Short / Extra',
                    expected_drawer_amount: 'Total Expected Drawer Amount',
                    closing_amount: 'Total Closing',
                    cash_out: 'Total Cash Out',
                    cash_in: 'Total Cash In',
                    price_before_modifiers: 'Gross Sales',
                },
                texts: {
                    title: 'Drawer Session',
                    description: 'Cashier session report',
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                templates: {
                    uuid: (h, row) => {
                        if (!row.uuid) return '';
                        return row.uuid.substring(0, 8);
                    },

                    time_open: (h, row) => {
                        return this.dateFormat(row.time_open);
                    },
                    time_close: (h, row) => {
                        return this.dateFormat(row.time_close);
                    },
                    price_before_modifiers: (h, row) => {
                        const result =
                            parseFloat(row.total_sales) -
                            (parseFloat(row.total_tax) +
                                parseFloat(row.total_charge) +
                                parseFloat(row.total_rounding)) +
                            parseFloat(row.total_discounts);
                        return numeral(result).format();
                    },
                    total_modifiers: (h, row) => {
                        return numeral(
                            parseFloat(row.total_modifiers),
                        ).format();
                    },
                    total_discounts: (h, row) => {
                        const discount =
                            parseFloat(
                                (row.total_discounts + '').replace(/,/g, ''),
                            ) * -1;
                        return numeral(discount).format();
                    },
                    net_sales: (h, row) => {
                        const result =
                            parseFloat(row.total_sales) -
                            (parseFloat(row.total_tax) +
                                parseFloat(row.total_charge) +
                                parseFloat(row.total_rounding));
                        return numeral(result).format();
                    },
                    total_sales: (h, row) => {
                        return numeral(parseFloat(row.total_sales)).format();
                    },
                    voided_sales: (h, row) => {
                        return numeral(parseFloat(row.voided_sales)).format();
                    },
                    voided_items: (h, row) => {
                        return numeral(parseFloat(row.voided_items)).format();
                    },
                    total_rounding: (h, row) => {
                        return numeral(parseFloat(row.total_rounding)).format();
                    },
                    total_cash: (h, row) => {
                        return numeral(parseFloat(row.total_cash)).format();
                    },
                    total_credit_card: (h, row) => {
                        return numeral(
                            parseFloat(row.total_credit_card),
                        ).format();
                    },
                    total_cheque: (h, row) => {
                        return numeral(parseFloat(row.total_cheque)).format();
                    },
                    total_voucher: (h, row) => {
                        return numeral(parseFloat(row.total_voucher)).format();
                    },
                    total_others: (h, row) => {
                        return numeral(parseFloat(row.total_others)).format();
                    },
                    opening_amount: (h, row) => {
                        return numeral(parseFloat(row.opening_amount)).format();
                    },
                    cash_in: (h, row) => {
                        return numeral(parseFloat(row.cash_in)).format();
                    },
                    cash_out: (h, row) => {
                        return numeral(parseFloat(row.cash_out)).format();
                    },
                    expected_drawer_amount: (h, row) => {
                        return numeral(
                            parseFloat(row.expected_drawer_amount),
                        ).format();
                    },
                    closing_amount: (h, row) => {
                        return numeral(parseFloat(row.closing_amount)).format();
                    },
                    short_extra: (h, row) => {
                        return numeral(parseFloat(row.short_extra)).format();
                    },
                },
                // pdf_url: Laroute.route('franchise.report.drawersession.exportAsFile', { type: 'PDF' }),
                csv_url: Laroute.route(
                    'franchise.report.drawersession.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.drawersession.exportAsFile',
                    { type: 'XLSX' },
                ),
                rowClickCallback: row => {
                    this.showEndShifReport(row.id);
                },
                rowClassCallback: () => 'pointer',
            },
        };
    },

    computed: {
        api() {
            return Laroute.route(
                'franchise.report.drawersession.drawerSessionList',
            );
        },
    },

    mounted() {
        this.setColumnDisplay();
    },

    methods: {
        setColumnDisplay() {
            this.$refs.datatable.userControlsColumns = true;
            this.$refs.datatable.userColumnsDisplay = [
                'uuid',
                'staff',
                'outlet',
                'time_open',
                'time_close',
                'price_before_modifiers',
                'total_discounts',
                'net_sales',
                'total_sales',
                'total_rounding',
                'total_cash',
                'total_credit_card',
                'total_others',
                'opening_amount',
                'cash_in',
                'cash_out',
                'expected_drawer_amount',
                'closing_amount',
                'short_extra',
            ];
        },

        showEndShifReport(id) {
            axios
                .get(
                    Laroute.route(
                        'franchise.report.drawersession.getCentralSetting',
                    ),
                )
                .then(
                    function(response) {
                        let data = response.data;
                        if (data) {
                            if (data.eod_template) {
                                this.$refs.endShiftReportV2.$emit(
                                    'show-end-shift-report',
                                    id,
                                );
                            } else {
                                this.$refs.endShiftReport.$emit(
                                    'show-end-shift-report',
                                    id,
                                );
                            }
                        } else {
                            this.$refs.endShiftReport.$emit(
                                'show-end-shift-report',
                                id,
                            );
                        }
                    }.bind(this),
                );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/drawersession/vuetable-drawer-session.vue